/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use this on my phone?`)
};

const es_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo usar esto en mi teléfono?`)
};

const de_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich dies auf meinem Telefon verwenden?`)
};

const nl_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik dit op mijn telefoon gebruiken?`)
};

const fr_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je utiliser ceci sur mon téléphone?`)
};

const it_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso utilizzare questo sul mio telefono?`)
};

const pt_br2_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usar isso no meu telefone?`)
};

const pt_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usar isto no meu telemóvel?`)
};

const ja_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートフォンでこれを使用できますか?`)
};

const zh_sig_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以在手机上使用吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_faq3_q", locale)
	if (locale === "en") return en_sig_hub_faq3_q(inputs)
	if (locale === "es") return es_sig_hub_faq3_q(inputs)
	if (locale === "de") return de_sig_hub_faq3_q(inputs)
	if (locale === "nl") return nl_sig_hub_faq3_q(inputs)
	if (locale === "fr") return fr_sig_hub_faq3_q(inputs)
	if (locale === "it") return it_sig_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_faq3_q(inputs)
	if (locale === "pt") return pt_sig_hub_faq3_q(inputs)
	if (locale === "ja") return ja_sig_hub_faq3_q(inputs)
	return zh_sig_hub_faq3_q(inputs)
};